import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/Minbus.otf%22,%22weight%22:%22100%22}]}],%22variableName%22:%22titleFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'titleFont', 'titleFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
